import {Box} from "@mantine/core"
import commonClasses from "../../../../common/common.module.css"
import classes from "./StatCard.module.css"
import cx from "clsx";
import {ReactNode} from "react";

export interface StatCardProps {
    stat: string | number
    statText: string
    substat?: string | number
    substatText?: string
    icon: ReactNode
}

export const StatCard: React.FC<Partial<StatCardProps>> = ({
                                                               stat,
                                                               statText,
                                                               substat,
                                                               substatText,
                                                               icon,
                                                           }: Partial<StatCardProps>) => {

    const formatStat = (stat: string | number | undefined) => {
        if (typeof stat === 'number') {
            // remove trailing zeros so we don't show 3.00 all the time
            return stat.toFixed(2).replace(/\.?0+$/,'')
        }
        return stat;
    }
    return (
        <Box
            className={cx(classes.root, commonClasses.glass0, commonClasses.dropshadowHover, commonClasses.sbRadius, commonClasses.tgBorder)}>
            {icon}
            <Box className={classes.stat}>{formatStat(stat)}</Box>
            {substat ? <Box
                className={cx(classes.substat, commonClasses.sbRadius)}>{substat} {substatText}</Box> : <></>}
            <Box className={cx(classes.statText, commonClasses.subtleText)}>{statText}</Box>
        </Box>
    )
}